var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.506 3.976a.6.6 0 0 1 .848 0l3.6 3.6a.6.6 0 0 1 0 .848l-3.6 3.6a.6.6 0 0 1-.848-.848L10.08 8.6H3.13a.6.6 0 1 1 0-1.2h6.951L7.506 4.824a.6.6 0 0 1 0-.848"
  })));
};
export default SvgArrowRight;